jQuery(document).ready(function($) {

  if($('.wf-ingredient-gallery').length) {
    if(window.location.hash && $('[data-open='+window.location.hash.substring(1)+']').length) {
      $('html, body').animate({
          scrollTop: $('[data-open='+window.location.hash.substring(1)+']').offset().top - ($('header.header').outerHeight()  || 0)
      }, 500, 'linear', function() {
        $('#'+window.location.hash.substring(1)).foundation('open');
        history.pushState("", document.title, window.location.pathname);
      });
    }
  }

});
